<div class="main">
    <h1>Settings</h1>

    <form [formGroup]="userSettingsForm" (ngSubmit)="onSubmit()">
        <div class="form-control">
            <div>
                <label for="email">Email</label>
            </div>
            <div>
                <input type="email" id="emailId" formControlName="emailId">
            </div>
        </div>

        <P></P>
        <div class="form-control">
            <label>Global notifications </label><f-tooltip
                content='When turned off,<br />you will not receive<br /> any notification in<br /> regards to your<br /> subscriptions.'
                trigger-event-type="hover" variant="info" position="top" class="tooltip"></f-tooltip>

            <!-- switch buttons-->
            <label class="padded-off-label">Off</label>
            <label class="switch">
                <input type="checkbox" id="notificationInd" formControlName="notificationInd">
                <span class="slider"></span>
            </label>
            <label class="padded-on-label">On</label>
        </div>

        <div class="form-control">
            <div class="button-row">
                <f-button text="Apply" variant="progressive" (buttonClicked)="onSubmit()">
                </f-button>
                <f-button type="button" text="Cancel" variant="action" (buttonClicked)="onCancel()">
                </f-button>
            </div>
        </div>
    </form>
    <div></div>
</div>